import React, { useEffect, useState, useMemo } from 'react';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { Button, Col, Row } from 'reactstrap';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import AlertCircleOutlineIcon from 'mdi-react/AlertCircleOutlineIcon';
import { connect } from 'react-redux';
import TimetableIcon from 'mdi-react/TimetableIcon';
import validate from '../validate';
import RenderField from '../../../shared/components/custom/Field';
import RenderTextAreaField from '../../../shared/components/custom/TextArea';
import RenderSelectField from '../../../shared/components/form/Select';
import renderRadioButtonField from '../../../shared/components/form/RadioButton';
import t, { partial } from '../../../util/translation/translation';
import Api from '../../../util/api';
import { TargetAudience } from './types';
import MessageTemplatesPage from '../MessageTemplatesPage';
import FormBox from '../../../shared/components/custom/FormBox';
import useConfig from '../../../util/useConfig';
import PreviewMessages from './PreviewsMessage';

const p = partial('MessagesForm');
const s = partial('shared');
const o = partial('OfferForm');
export const scheduleIntervals = [
  {
    label: t('ScheduledMessagesPage.scheduleInterval-dontRepeat'),
    value: null,
  },
  {
    label: t('ScheduledMessagesPage.scheduleInterval-1day'),
    value: 24 * 60 * 60 * 1000,
  },
  {
    label: t('ScheduledMessagesPage.scheduleInterval-1week'),
    value: 7 * 24 * 60 * 60 * 1000,
  },
  {
    label: 'test-5-minutes',
    value: 5 * 60 * 1000,
  },
];
const MessagesForm = ({
  handleSubmit,
  smsForm,
  checkRecieversAndSendMessage,
  initialize,
  change,
  me,
  setScheduleMessageID,
  formValues,
  scheduleMessageID,
  clearContactPage,
  setClearContactPage,
  startDate,
  setStartDate,
  storeTemplate,
  template,
  useTemplate,
}) => {
  const config = useConfig();
  const [notificationLabels, setNotificationLabels] = useState([]);
  const [selectedScreen, setSelectedScreen] = useState(undefined);
  const [groups, setGroups] = useState(null);
  const [targetAudience, setTargetAudience] = useState(TargetAudience.all);
  const [levels, setLevels] = useState(null);
  const [tiers, setTiers] = useState(null);
  const [segments, setSegments] = useState(null);
  const screens = [
    {
      label: p('homeScreen'),
      value: '/home/false',
      values: [{ label: p('homeScreen'), value: '-1' }],
    },
    {
      label: p('events'),
      value: '/more/eventStack/events',
      values: [{ label: `${p('frontpage')} ${p('events')}`, value: '-1' }],
    },
    {
      label: p('lotteries'),
      value: '/more/lotteryStack/lotteriesScreen',
      values: [{ label: `${p('frontpage')} ${p('lotteries')}`, value: '-1' }],
    },
    {
      label: p('auctions'),
      value: '/more/auctions/Auctions',
      values: [{ label: `${p('frontpage')} ${p('auctions')}`, value: '-1' }],
    },
    {
      label: p('news'),
      value: '/home/news/false',
      values: [{ label: `${p('frontpage')} ${p('news')}`, value: '-1' }],
    },
  ];
  const getScreens = async () => {
    try {
      setSelectedScreen(screens[0]);
      initialize({
        type: screens[0],
        // group: undefined,
        mode: screens[0]?.values[0],
        media: 'push',
        targetAudience: 'all',
        groups: [
          {
            label: 'Ignore',
            value: null,
          },
        ],
        levels: [
          {
            label: 'Ignore',
            value: null,
          },
        ],
        tiers: [
          {
            label: 'Ignore',
            value: null,
          },
        ],
        segments: [
          {
            label: 'Ignore',
            value: null,
          },
        ],
        timeToSend: 'INSTANT',
        scheduleInterval: scheduleIntervals[0],
      });
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };
  useEffect(() => {
    if (template && groups && levels && tiers && segments) {
      clearFields({
        heading: template.title,
        message: template.text,
        externalUrlAddress: template.url,
        landingPageCategory: screens.find(
          (item) => item.value === template.landingPageCategory
        ),
        targetAudience: template.targetAudience.targetAudience,
        groups:
          template.targetAudience.groups.length > 0
            ? template.targetAudience.groups.map((groupId) => {
                return {
                  label:
                    groupId === 'all groups'
                      ? s('all')
                      : groups.find((group) => group.value === groupId)?.label,
                  value: groupId === 'all groups' ? [] : groupId,
                };
              })
            : [
                {
                  label: 'Ignore',
                  value: null,
                },
              ],
        levels:
          template.targetAudience.levels.length > 0
            ? template.targetAudience.levels.map((levelId) => {
                return {
                  label:
                    levelId === 'all levels'
                      ? s('all')
                      : levels.find((level) => level.value === levelId)?.label,
                  value: levelId === 'all levels' ? [] : levelId,
                };
              })
            : [
                {
                  label: 'Ignore',
                  value: null,
                },
              ],
        tiers:
          template.targetAudience.tiers.length > 0
            ? template.targetAudience.tiers.map((tierId) => {
                return {
                  label:
                    tierId === 'all'
                      ? s('all')
                      : tiers.find((tier) => tier.value === tierId)?.label,
                  value: tierId === 'all' ? [] : tierId,
                };
              })
            : [
                {
                  label: 'Ignore',
                  value: null,
                },
              ],
        segments:
          template.targetAudience.segments.length > 0
            ? template.targetAudience.segments.map((segmentId) => {
                return {
                  label:
                    segmentId === 'all segments'
                      ? s('all')
                      : segments.find((segment) => segment.value === segmentId)
                          ?.label,
                  value: segmentId === 'all segments' ? [] : segmentId,
                };
              })
            : [
                {
                  label: 'Ignore',
                  value: null,
                },
              ],
      });
    }
  }, [template, groups, levels, tiers, segments]);
  const getData = async () => {
    try {
      const [
        resLevels,
        resGroups,
        resTiers,
        resSegments,
        resNotificationLabels,
      ] = await Promise.all([
        Api.club.getLevels(),
        Api.club.getGroups(),
        Api.tiers.allTiers(),
        Api.spotlight.getSegments(),
        Api.userDevices.getAllNotificationLabels(),
      ]);
      setLevels([
        {
          label: 'Ignore',
          value: null,
        },
        {
          label: s('all'),
          value: [],
        },
        ...resLevels.map((level) => {
          const { id, value } = level;
          return {
            value: id,
            label: value,
          };
        }),
      ]);
      setNotificationLabels(
        resNotificationLabels.map((label) => ({
          value: label.id,
          label: label.title,
        }))
      );
      setGroups([
        {
          label: 'Ignore',
          value: null,
        },
        {
          label: s('all'),
          value: [],
        },
        ...resGroups.map((group) => {
          const { id, value } = group;
          return {
            value: id,
            label: value,
          };
        }),
      ]);

      setTiers([
        {
          label: 'Ignore',
          value: null,
        },
        {
          label: s('all'),
          value: [],
        },
        ...resTiers.data.map((tier) => ({
          label: tier.name,
          value: tier.id,
        })),
      ]);

      setSegments([
        {
          label: 'Ignore',
          value: null,
        },
        {
          label: s('all'),
          value: [],
        },
        ...resSegments.map((segment) => ({
          value: segment.id,
          label: segment.name,
        })),
      ]);
    } catch (err) {
      toast.error(err);
    }
  };
  const handleClearSelectInput = () => {
    if (smsForm.group) {
      const groupLength = smsForm.group.length;
      const allGroupIndex = smsForm.group.findIndex(
        (item) =>
          item.value?.type === 'internal' && item.value?.groupId === 'all'
      );
      if (groupLength > 1 && allGroupIndex !== -1) {
        const isLast = allGroupIndex === groupLength - 1;
        if (isLast) {
          change('group', [smsForm.group[allGroupIndex]]);
        } else {
          const filteredGroups = smsForm.group.filter(
            (item) =>
              !(
                item.value?.type === 'internal' && item.value?.groupId === 'all'
              )
          );
          change('group', filteredGroups);
        }
      }
    }
  };
  const clearFields = ({
    heading,
    message,
    externalUrlAddress,
    landingPageCategory,
    groups,
    levels,
    tiers,
    segments,
    targetAudience,
  } = {}) => {
    setScheduleMessageID(null);
    setClearContactPage(false);
    setTargetAudience(targetAudience || 'all');
    setStartDate('');
    initialize({
      media: 'push',
      heading: heading || '',
      message: message || '',
      type: landingPageCategory || screens[0],
      mode: selectedScreen?.values[0],
      group: '',
      notificationLabel: null,
      externalUrlAddress: externalUrlAddress || '',
      timeToSend: 'INSTANT',
      targetAudience: targetAudience || 'all',
      groups: groups || [
        {
          label: 'Ignore',
          value: null,
        },
      ],
      levels: levels || [
        {
          label: 'Ignore',
          value: null,
        },
      ],
      tiers: tiers || [
        {
          label: 'Ignore',
          value: null,
        },
      ],
      segments: segments || [
        {
          label: 'Ignore',
          value: null,
        },
      ],
      scheduleTime: null,
      scheduleInterval: scheduleIntervals[0],
    });
  };

  useEffect(() => {
    clearFields();
  }, [clearContactPage]);

  const adjustDropdowns = (fieldName) => {
    if (smsForm[fieldName] && smsForm[fieldName].length > 1) {
      const [old, ...newOnes] = smsForm[fieldName];
      const newestOne = smsForm[fieldName][smsForm[fieldName].length - 1];
      if (old.value === null || Array.isArray(old.value)) {
        change(fieldName, newOnes);
      }
      if (newestOne.value === null || Array.isArray(newestOne.value)) {
        change(fieldName, [newestOne]);
      }
    }
  };

  useEffect(() => {
    adjustDropdowns('groups');
    adjustDropdowns('levels');
    adjustDropdowns('tiers');
    adjustDropdowns('segments');
  }, [smsForm.levels, smsForm.groups, smsForm.tiers, smsForm.segments]);

  useEffect(() => {
    if (me?.username !== '') {
      getScreens();
      getData();
    }
  }, [me]);
  useEffect(() => {
    handleClearSelectInput();
  }, [smsForm.group]);

  const submitButtonName = useMemo(() => {
    let buttonName = '';
    if (scheduleMessageID) {
      buttonName = `${t('ScheduledMessagesPage.updateMessage')}`;
    } else if (formValues?.timeToSend === 'SCHEDULED') {
      buttonName = t('ScheduledMessagesPage.scheduleMessage');
    } else {
      buttonName = p('sendMessage');
    }
    return buttonName;
  }, [scheduleMessageID, formValues]);

  return (
    <form className="form">
      <Col md={6}>
        <div>
          <div className="radio-horizontal">
            <div className="form__form-group margin-0">
              <div className="form__form-group-field">
                <Field
                  name="media"
                  component={renderRadioButtonField}
                  label={p('pushMessage')}
                  radioValue="push"
                  defaultChecked
                />
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="media"
                  component={renderRadioButtonField}
                  label="SMS"
                  radioValue="sms"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1 marginRight-15">
          <FormBox title={s('content')}>
            <Col md={12}>
              <div className="form__form-group">
                <span className="form__form-group-label ">{s('title')}</span>
                {smsForm.media === 'sms' ? (
                  <Field
                    style={{ margin: '-10px !important' }}
                    name="heading"
                    component={RenderField}
                    placeholder={`${s('title')}`}
                    disabled={smsForm.media === 'sms'}
                  />
                ) : (
                  <div
                    className="form__form-group-field"
                    style={{ margin: '-5px -10px' }}
                  >
                    <Field
                      style={{ margin: '-10px !important' }}
                      name="heading"
                      component={RenderField}
                      placeholder={`${s('title')}`}
                      emoji
                    />
                  </div>
                )}
              </div>
            </Col>
            <Col md={12}>
              <div className="form__form-group">
                <span className="form__form-group-label ">{s('message')}</span>
                <div
                  className="form__form-group-field"
                  style={{ margin: '-5px -10px' }}
                >
                  <Field
                    name="message"
                    component={RenderTextAreaField}
                    placeholder={s('message')}
                    emoji
                  />
                </div>
              </div>
            </Col>
          </FormBox>
          <FormBox style={{ marginTop: 10 }} title={o('targetAudience')}>
            <Row>
              <Col md={12}>
                <div className="radio-horizontal p-2">
                  <div className="form__form-group margin-0">
                    <div className="form__form-group-field">
                      <Field
                        name="targetAudience"
                        component={renderRadioButtonField}
                        label={s('all')}
                        radioValue={TargetAudience.all}
                        onChange={(e) => setTargetAudience(e)}
                      />
                    </div>
                  </div>
                  <div className="form__form-group margin-0">
                    <div className="form__form-group-field">
                      <Field
                        name="targetAudience"
                        component={renderRadioButtonField}
                        label={s('custom')}
                        radioValue="custom"
                        onChange={(e) => setTargetAudience(e)}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="form__form-group p-2">
              {targetAudience === 'custom' && (
                <>
                  <Row>
                    <Col md={12}>
                      <div className="form__form-group">
                        <span className="form-header">
                          {t('HighlightBannerForm.selectSegments')}
                        </span>
                        <Field
                          name="segments"
                          placeholder={t('HighlightBannerForm.selectSegments')}
                          options={segments}
                          component={RenderSelectField}
                          multiple
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="form__form-group">
                        <span className="form-header">{o('selectLevels')}</span>
                        <Field
                          name="levels"
                          placeholder={o('selectLevels')}
                          options={levels}
                          component={RenderSelectField}
                          multiple
                        />
                      </div>
                      <div className="form__form-group">
                        <span className="form-header">{p('chooseGroup')}</span>
                        <Field
                          name="groups"
                          placeholder={p('chooseGroup')}
                          options={groups}
                          component={RenderSelectField}
                          multiple
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="form__form-group">
                        <span className="form-header">Choose a tier</span>
                        <Field
                          name="tiers"
                          placeholder="Choose a tier"
                          options={tiers}
                          component={RenderSelectField}
                          multiple
                        />
                      </div>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          </FormBox>
          <FormBox style={{ marginTop: 10 }} title={t('OfferCard.other')}>
            <Row className="p-2">
              <Col md={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {s('categoryLanding')}
                  </span>
                  <div className="form__form-group-field d-flex">
                    <Field
                      name="type"
                      component={RenderSelectField}
                      placeholder={p('chooseScreen')}
                      options={screens}
                      onChange={(event, newValue) => {
                        setSelectedScreen(newValue);
                        change('mode', newValue?.values?.[0] ?? '');
                      }}
                      disabled={smsForm.media === 'sms'}
                    />
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {p('addExternalUrl')}
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      name="externalUrlAddress"
                      component={RenderField}
                      placeholder={p('externalUrlPlaceholder')}
                      disabled={smsForm.media === 'sms'}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="p-2">
              <Col md={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {s('notificationLabel')}
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      name="notificationLabel"
                      component={RenderSelectField}
                      placeholder={p('chooseNotificationLabel')}
                      options={notificationLabels}
                      disabled={smsForm.media === 'sms'}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </FormBox>
          <FormBox
            style={{ marginTop: 10 }}
            title={t('ScheduledMessagesPage.timeToSend')}
          >
            <Row className="p-2">
              <Col md={12}>
                <div className="radio-horizontal">
                  <div className="form__form-group margin-0">
                    <div className="form__form-group-field">
                      <Field
                        name="timeToSend"
                        component={renderRadioButtonField}
                        label={t('shared.instant')}
                        radioValue="INSTANT"
                        defaultChecked
                      />
                    </div>
                  </div>
                  <div className="form__form-group">
                    <div className="form__form-group-field">
                      <Field
                        name="timeToSend"
                        component={renderRadioButtonField}
                        label={t('shared.scheduled')}
                        radioValue="SCHEDULED"
                      />
                    </div>
                  </div>
                </div>
              </Col>
              {formValues?.timeToSend === 'SCHEDULED' && (
                <>
                  <Col md={4}>
                    <div className="form__form-group" style={{ zIndex: 100 }}>
                      <span className="form-header">
                        {t('ScheduledMessagesPage.scheduleTime')}
                      </span>
                      <div className="form__form-group-field">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => {
                            setStartDate(date);
                            change('scheduleTime', date);
                          }}
                          locale="pt-BR"
                          showTimeSelect
                          timeFormat="p"
                          timeIntervals={15}
                          dateFormat="Pp"
                          minDate={new Date()}
                          placeholderText="DD / MM / YYYY  -- : --"
                          disabledKeyboardNavigation
                        />
                        <div className="form__form-group-icon">
                          <TimetableIcon />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="form__form-group" style={{ zIndex: 100 }}>
                      <span className="form-header">
                        {t('ScheduledMessagesPage.scheduleInterval')}
                      </span>
                      <div className="form__form-group-field d-flex">
                        <Field
                          name="scheduleInterval"
                          component={RenderSelectField}
                          placeholder={t(
                            'ScheduledMessagesPage.scheduleInterval'
                          )}
                          options={scheduleIntervals}
                          disabled={
                            startDate === null ||
                            startDate === undefined ||
                            startDate === ''
                          }
                        />
                      </div>
                    </div>
                  </Col>
                </>
              )}
            </Row>
          </FormBox>
        </div>
        <Row className="mt-3">
          <Col>
            <Button
              style={{ marginBottom: 0 }}
              size="sm"
              color="success"
              disabled={!formValues?.heading || !formValues?.message}
              onClick={handleSubmit((values) => {
                storeTemplate(values);
              })}
            >
              {t('ScheduledMessagesPage.storeTemplate')}
            </Button>
            {scheduleMessageID && (
              <Button onClick={clearFields}>{t('shared.clear')}</Button>
            )}
            {/*<Button
                type="button"
                onClick={handleSubmit((values) => {
                  checkRecieversAndSendMessage(true, values);
                })}
                disabled={formValues?.timeToSend === 'SCHEDULED'}
              >
                {p('checkAmountOfRecievers')}
              </Button>*/}
            <Button
              style={{ marginBottom: 0 }}
              type="button"
              size="sm"
              onClick={handleSubmit((values) => {
                checkRecieversAndSendMessage(false, values, me);
              })}
              disabled={formValues?.timeToSend === 'SCHEDULED'}
            >
              {p('testToSelf', { number: me?.username })}
            </Button>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={12}>
            <div>
              <Button
                type="button"
                color="primary"
                onClick={handleSubmit((values) => {
                  checkRecieversAndSendMessage(false, values);
                })}
              >
                {submitButtonName}
              </Button>
            </div>
          </Col>
        </Row>
      </Col>
      <Col md={6}>
        <Col className="mb-2">
          <strong className="">{t('NewsForm.appPreview')}</strong>
          <PreviewMessages formValues={formValues} />
        </Col>
        <hr />
        <MessageTemplatesPage useButton initializeTemplate={useTemplate} />
        <span>&nbsp;</span>
        <div className="flex align-items-center p-3 border">
          <div className="modal-icon m-2">
            <AlertCircleOutlineIcon size="38" />
          </div>
          <div>
            <p>{p('pushInformation')}</p>
            <p>{p('AppStorePushGuidelines')}</p>
          </div>
        </div>
      </Col>
    </form>
  );
};

MessagesForm.propTypes = {
  me: PropTypes.shape({
    username: PropTypes.string,
  }),
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  smsForm: PropTypes.shape({
    media: PropTypes.string,
    targetAudience: PropTypes.string,
    timeToSend: PropTypes.string,
  }),
  initialize: PropTypes.func.isRequired,
  checkRecieversAndSendMessage: PropTypes.func.isRequired,
};

MessagesForm.defaultProps = {
  smsForm: {
    media: 'push',
    targetAudience: 'all',
    timeToSend: 'INSTANT',
  },
  me: { username: '' },
};

const mapStateToProps = (state) => ({
  formValues: getFormValues('send_messages_form')(state),
});

export default reduxForm({
  form: 'send_messages_form',
  validate,
})(connect(mapStateToProps)(MessagesForm));
